import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import type { SectionTitleProps } from './types';
export const SectionTitle: React.FC<SectionTitleProps> = t0 => {
  const $ = _c(28);
  const {
    heading,
    icon,
    border,
    spacing: altSpacing
  } = t0;
  const {
    IconElement,
    iconNode
  } = icon;
  const t1 = `${border?.width || "4px"} solid`;
  const t2 = border?.color || "primary.main";
  const t3 = border?.customStyle;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = {
      borderBottom: t1,
      borderColor: t2,
      marginBottom: 3,
      ...t3
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = altSpacing?.gap || 3;
  const t6 = altSpacing?.paddingY || 2;
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = {
      display: "flex",
      alignItems: "center",
      gap: t5,
      paddingY: t6
    };
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== IconElement || $[8] !== icon.color || $[9] !== icon.customCSSStyle || $[10] !== icon.customStyle || $[11] !== icon.size || $[12] !== iconNode) {
    t8 = iconNode ?? (IconElement && <IconElement sx={{
      fontSize: icon?.size || "2rem",
      color: icon?.color || "primary.main",
      ...icon?.customStyle
    }} {...icon?.customCSSStyle && {
      style: icon?.customCSSStyle
    }} data-testid="section-title-icon" />);
    $[7] = IconElement;
    $[8] = icon.color;
    $[9] = icon.customCSSStyle;
    $[10] = icon.customStyle;
    $[11] = icon.size;
    $[12] = iconNode;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = heading?.color || "primary.main";
  const t10 = heading?.size || "1.5rem";
  const t11 = heading?.customStyle;
  let t12;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t9) {
    t12 = {
      color: t9,
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: t10,
      lineHeight: 1.2,
      letterSpacing: "0.8125px",
      ...t11
    };
    $[14] = t10;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== heading.text || $[19] !== t12) {
    t13 = <Typography variant="text" component="h2" sx={t12}>{heading.text}</Typography>;
    $[18] = heading.text;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t7 || $[23] !== t8) {
    t14 = <Box data-testid="section-title-content" sx={t7}>{t8}{t13}</Box>;
    $[21] = t13;
    $[22] = t7;
    $[23] = t8;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t4) {
    t15 = <Box data-testid="section-title" sx={t4}>{t14}</Box>;
    $[25] = t14;
    $[26] = t4;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};